import MapboxDraw from '@mapbox/mapbox-gl-draw';
import FreehandMode from 'mapbox-gl-draw-freehand-mode';
import { useState } from 'react';
import { useControl } from 'react-map-gl';

class SatLayerToggle {
  constructor(props) {
    this.props = props;
  }
  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.button = document.createElement('button');
    this.container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    this.button.className = 'style-control-btn';
    this.container.append(this.button);
    this.button.addEventListener('mousedown', () => {
      this.props.onUpdate();
    });
    return this.container;
  }
  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

export function StyleControl(props) {
  useControl(() => new SatLayerToggle(props), {
    position: props.position,
  });

  return null;
}

export default function DrawControl(props) {
  const [justDrew, setJustDrew] = useState(false);

  const draw = new MapboxDraw({
    ...props,
    modes: Object.assign(MapboxDraw.modes, {
      draw_polygon: FreehandMode,
    }),
  });

  useControl(
    () => draw,
    ({ map }) => {
      let hasDrawn = false;

      // event -> null
      // finds all the points within the created polygon that can be selected and then deletes
      // the polygon, creating a simple user flow and allows us to not have to handle diffing
      // selections on poly update / delete
      map.on('draw.create', (e) => {
        hasDrawn = true;
        props.onCreate(e);
        draw.deleteAll();
      });

      map.on('draw.modechange', (e) => {
        if (hasDrawn) {
          draw.changeMode('draw_polygon');
          hasDrawn = false;
        }
      });

      map.on('draw.delete', (e) => {});
    },
    ({ map }) => {
      map.off('draw.create', (e) => {
        props.onCreate(e);
      });
    },
    {
      position: props.position,
    }
  );

  return null;
}

DrawControl.defaultProps = {
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {},
};

StyleControl.defaultProps = {
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {},
};
